import { SVG_NS } from './constants';
import { sanitizeSVGTree } from './sanitize';

/**
 * 解析并清理 SVG 素材字符串。
 *
 * @param source - SVG 素材文本。
 * @returns 解析成功且可安全渲染的根 SVG；格式无效时返回 null。
 */
export const parseSVG = (source: string): SVGSVGElement | null => {
    const documentNode = new DOMParser().parseFromString(source, 'image/svg+xml');
    // Document.documentElement 在 TypeScript DOM 定义中是 HTMLElement。先提升为共同基类
    // Element，再通过下面的 namespace 与标签校验收窄其运行时语义，避免跨兄弟类型断言报错。
    const root: Element = documentNode.documentElement;

    if (documentNode.querySelector('parsererror')) return null;
    if (root.namespaceURI !== SVG_NS || root.localName.toLowerCase() !== 'svg') return null;

    const svgRoot = root as SVGSVGElement;

    // 矢量链路历史上允许三类外部资源，因此显式关闭对应共享策略。
    sanitizeSVGTree(svgRoot, {
        removeExternalHrefs: false,
        removeExternalStyleResources: false,
        removeExternalStyleAttributeURLs: false,
    });

    // javascript: 属性值过滤是矢量链路的历史规则，不改变现有素材行为。
    [svgRoot, ...Array.from(svgRoot.querySelectorAll('*'))].forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
            const value = attribute.value.trim().toLowerCase();

            if (value.includes('javascript:')) {
                element.removeAttribute(attribute.name);
            }
        });
    });

    return svgRoot;
};
